import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FilterDateRangeV2 from '../../home/components/filters/FilterDateRangeV2'
import FilterProductType from './FilterProductType'
import {Input} from 'antd'
import FilterUserCut from "./FilterUserCut";

const {Search} = Input
class FilterLazeCutting extends Component {

    _handleChangeName = (value) => {
        const { handleChangeInput } = this.props

        if (typeof handleChangeInput === 'function') {
            handleChangeInput(value)
        }
    }

    _handleChange = e => {
        const {value} = e.target

        if (this._timeOut) clearTimeout(this._timeOut)

        this._timeOut = setTimeout(() => {
            this._handleChangeName(value)
        }, 500)
    }

    _handleChangeDate = (field, value) => {
        const { handleChangeDate } = this.props
        const cloneFilter = Object.assign({}, this.props.startCuttingAt)

        cloneFilter[field] = value

        if (value.from === '' || value.to === '') {
            delete cloneFilter[field]
        }

        handleChangeDate(cloneFilter)
    }

    render() {
        const { productTypes, onChangeProductType, usersCut, onChangeUsersCut } = this.props

        return (
            <div className='BatchesPageContainer'>
                <div className='row align-items-end'>
                    <div className='FilterNameBatch col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold">Tên lô</label>
                        <div className='SearchField'>
                            <Search placeholder='Tìm kiếm theo tên Lô...' onChange={this._handleChange} allowClear={true} />
                        </div>
                    </div>
                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold">Ngày cắt</label>
                        <FilterDateRangeV2 field='created_at' onDatesChange={this._handleChangeDate} showTime={true}/>
                    </div>


                    <div className='col-12 col-xl-4 mb-3'>
                        <label className="font-weight-bold">Loại sản phẩm</label>
                        <FilterProductType
                            productTypes={productTypes}
                            onChangeProductType={onChangeProductType}
                        />
                    </div>

                    <div className='col-12 col-xl-4 mb-3'>
                        <label className="font-weight-bold">Người cắt</label>
                        <FilterUserCut
                            usersCut={usersCut}
                            onChangeUsersCut={onChangeUsersCut}
                        />
                    </div>
                </div>
            </div>
        )
    }

}

FilterLazeCutting.defaultProps = {
    showPartner: true
}

FilterLazeCutting.propTypes = {
    loading: PropTypes.bool,
    onChangeProductType: PropTypes.func.isRequired,
    onChangeUsersCut: PropTypes.func.isRequired,
    handleChangeDate: PropTypes.func.isRequired,
    handleChangeInput: PropTypes.func.isRequired,
}

export default FilterLazeCutting
